@if (!isAllSelected) {
  <a href class="text-muted small underline" style="cursor: pointer" (click)="selectAll($event, true)">
    {{ 'common.select_all' | translate }}
  </a>
} @else {
  <a href class="text-muted small underline" style="cursor: pointer" (click)="selectAll($event, false)">
    {{ 'common.deselect_all' | translate }}
  </a>
}
